import { render, staticRenderFns } from "./ResultFormAi.vue?vue&type=template&id=77c9f0da&scoped=true&"
import script from "./ResultFormAi.vue?vue&type=script&lang=js&"
export * from "./ResultFormAi.vue?vue&type=script&lang=js&"
import style0 from "./ResultFormAi.vue?vue&type=style&index=0&id=77c9f0da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c9f0da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77c9f0da')) {
      api.createRecord('77c9f0da', component.options)
    } else {
      api.reload('77c9f0da', component.options)
    }
    module.hot.accept("./ResultFormAi.vue?vue&type=template&id=77c9f0da&scoped=true&", function () {
      api.rerender('77c9f0da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/IntelligentBookingResultMultiNew/components/ResultFormAi.vue"
export default component.exports